const blockCls = "c2lbkrfao7";
const inputWrapperCls = "c2li147qwnc";
const inputCls = "c2lihvox49";
const pencilCls = "c2lpr9q3jo";
const buttonsCls = "c2lb1ne0crw";
const handleCls = "c2lh1r0t11k";

export { blockCls, buttonsCls, handleCls, inputCls, inputWrapperCls, pencilCls };
import "./block.style.linaria.module.css";
//# sourceMappingURL=block.style.js.map
